import gql from 'graphql-tag';

import type { BlogPostBuilderBrief } from 'src/data/blog';
import type { AllInstructionsData, Language, TovInput } from 'src/data/generation';
import type { UrlExtraction } from 'src/data/types';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderDescription(
    $id: ID!
    $description: String!
    $customerPersonaId: ID
    $tovInput: TovInput
    $urlExtractions: [UrlExtractionInput!]
    $language: String
    $generationCustomModelId: ID
    $freestyleToolAllInstructionsData: JSON
  ) {
    updateBlogPostBuilderDescription(
      id: $id
      description: $description
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      urlExtractions: $urlExtractions
      language: $language
      generationCustomModelId: $generationCustomModelId
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
    ) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

interface Variables extends GqlCallVariables {
  id: ID;
  description: string;
  customerPersonaId?: ID;
  tovInput?: TovInput;
  urlExtractions?: UrlExtraction[];
  language?: Language;
  generationCustomModelId?: ID;
  freestyleToolAllInstructionsData?: AllInstructionsData;
}

export const updateBlogPostBuilderDescription = async (
  variables: Variables
): Promise<BlogPostBuilderBrief | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      freestyleToolAllInstructionsData: stringifyIfPresent(
        variables.freestyleToolAllInstructionsData
      ),
    },
  });

  return getSingleProp<BlogPostBuilderBrief>(result.data);
};
